"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _pages = require("./pages");
Object.keys(_pages).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pages[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _pages[key];
    }
  });
});
var _eventTracking = require("./eventTracking");
Object.keys(_eventTracking).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _eventTracking[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _eventTracking[key];
    }
  });
});
var _TagManager = require("./TagManager");
Object.keys(_TagManager).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TagManager[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TagManager[key];
    }
  });
});